import { icons, isEmpty } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'

import render from './render'

export default {
  name: 'GenerationParams',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    icon() {
      if (!isEmpty(this.value?.length)) {
        return icons[123]
      } else if (!isEmpty(this.value?.pattern)) {
        return icons.pattern
      }

      return icons.settings
    },

    hint() {
      let field
      if (!isEmpty(this.value?.length)) {
        field = 'length'
      } else if (!isEmpty(this.value?.pattern)) {
        field = 'pattern'
      }
      if (!field) {
        return this.getTranslate(`${serviceNameViaPoint}.hints.generationParams.empty`)
      }

      return this.getTranslate(
        `${serviceNameViaPoint}.hints.generationParams.templates.${field}`,
        { [field]: this.value?.[field] }
      )
    }
  },

  render
}
